export default __webpack_public_path__ + "static/media/pct.a1850199.svg";